export default __webpack_public_path__ + "static/media/2021-Estados-Financieros-Consolidados.96ae10b3.webp";